const getDefault = () => {
    return {
        authorization: null,
        // nickname: "",
        // avatar: "",
    };
};

const state = getDefault();

const mutations = {
    SET_AUTHORIZATION: (state, data) => {
        state.authorization = data.authorization;
        // state.nickname = data.nickname;
        // state.avatar = data.avatar;
    },
    SET_LOGOUT: (state) => {
        Object.assign(state, getDefault());
    },
};

const actions = {
    changeToken({ commit }, data) {
        commit("SET_AUTHORIZATION", data);
    },

    logout({ commit }) {
        commit("SET_LOGOUT");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
